import { Link } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import { handleInstitucional } from '../../api/institucional';


const about_info = {
  reviews: '8,200+',
  about_img: '/assets/img/Capa-02-2.png',
  about_banner: '/assets/img/about/about-banner.jpg',
  students_imgs: ['/assets/img/about/student-4.jpg', '/assets/img/about/student-3.jpg',
  '/assets/img/about/student-2.jpg', '/assets/img/about/student-1.jpg'],
  students: '4,000+',
  title: <>Prestenção na Pricillaine, <br /></>,
  shape_text: ' meu fi!',
  title_2: '  ',
  desc: "Meu filhoooo, bora escrever redação?!!<br>Galera, para ter um bom desempenho, é imprescindível escrever, isso vocês sabem, certo? Porém, o que a maioria esquece é que é essencial ter a redação corrigida!<br>De nada adianta vocês produzirem e não saberem o desempenho de vocês! Por isso estou aqui, não só para corrigi-los, mas também para indicar o “caminho das pedras! <br>Com uma correção muito detalhada e específica (de acordo com os critérios de cada Banca), você aprenderá, de uma vez por todas, a escrever redação. E o melhor: a nunca mais errar!<br>Agora, com a minha plataforma, você não precisará mais enviar a sua redação para a tia do vizinho do seu primo – aquela que tirou uma boa nota em redação lá em 1900 e bolinhas corrigir!<br>Doutoranda em Letras e com ampla experiência na área, disponibilizo a vocês o que há de mais rígido e completo no tocante às correções.<br> Bora escrever redação, meu fi!!!!!!!",
  about_list: ['Conteúdo online', 'Correções individual e online', 'Aprenda a escrever redação  ']
}

const SobreArea = () => {
  
  const [institucional, setInstitucional] = useState([]);
  const [htmlContent, setHtmlContent] = useState("");
  
  useEffect(function() {
    handleInstitucional().then(function(result) {
      setInstitucional(result[0]);
      console.log('result', result);
      setHtmlContent(result[0].descricao);
    });
  }, []);

  function HtmlRenderer({ htmlContent }) {
    return (
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    );
  }
  
  return (
    <>
    <section className="category__area pt-100 pb-70" style={{backgroundColor: "#033358"}}>
    <div className="container">
    <div className="row">
    {/* <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-8">
    <div className="about__thumb-wrapper">
    
      <div className="about__thumb">
      <img src={about_info.about_img} alt="" />
      </div>
    
    </div>
    </div>
     */}
    <div className="col-xxl-12 col-xl-12 col-lg-12">
    <div className="section__title-wrapper mt-45 mb-45">
    <h2 className="section__title" style={{color: "#fff"}}>Prof.ª <span className="yellow-bg">Pri <img src="/assets/img/shape/yellow-bg-2.png" alt="" />  </span>Záttera</h2><h3 style={{color: "#fff"}}>{ institucional.titulo }</h3>
    </div>
    <div className="about__list about__text mb-35">
    <HtmlRenderer htmlContent={htmlContent} />
    </div>
    </div>
    </div>
    
    </div>
    </section>
    </>
    );
  };
  
  export default SobreArea;